/* eslint no-console:0 */

import GAReport from 'src/ga_report';

GAReport.init();
